// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2WDue","Desktop":"Toolbar_Desktop__1ue6v","MenuToggle":"Toolbar_MenuToggle__1PIYA","Logo":"Toolbar_Logo__1ROPU"};